module.exports = __webpack_public_path__ + "media/logos-3brands-fullcolor.ce15ddf1.svg";